

export const apiData = [{repoName:'u4gwkjlp'},{uploadURL: 'https://api.cloudinary.com/v1_1/dpcytyz7w/image/upload'}];